import {defineStore} from "pinia";
import {ref} from "vue";
import router from '@/router/index';
import {removeLocalStorage} from "@/assets/js/commonUtil.js";

export const useRouterStore = defineStore(
    'routerHistoryStack',
    () => {
        const routerHistoryStack = ref([]);

        const pushRouterHistoryStack = (routerData) => {
            if (routerData.name) {
                if (routerHistoryStack.value.length > 0) {
                    const routerName = routerHistoryStack.value[routerHistoryStack.value.length - 1];
                    if (routerData.name !== routerName) {
                        routerHistoryStack.value.push(routerData.name);
                    }
                } else {
                    routerHistoryStack.value.push(routerData.name);
                }
            }
        }

        const delRouterHistoryStack = () => {
            if (routerHistoryStack.value.length > 0) {
                routerHistoryStack.value.splice(routerHistoryStack.value.length - 1, 1);
            }
        }

        const clearRouterHistoryStack = () => {
            routerHistoryStack.value = [];
            removeLocalStorage('routerHistoryStack');
        }

        const forward = (routerData) => {
            pushRouterHistoryStack(routerData);
            router.push(routerData);
        }

        const replace = (routerData) => {
            delRouterHistoryStack();
            pushRouterHistoryStack(routerData);
            router.replace(routerData);
        }

        const back = () => {
            try {
                if (routerHistoryStack.value.length < 2) {
                    delRouterHistoryStack();
                } else {
                    delRouterHistoryStack();
                    router.back();
                }
            } catch (e) {
                delRouterHistoryStack();
                router.back();
            }
        }

        /*获取当前路由对象*/
        const getCurrentRoute = () => {
            return router.currentRoute.value;
        }

        return {
            routerHistoryStack,
            pushRouterHistoryStack,
            delRouterHistoryStack,
            clearRouterHistoryStack,
            forward,
            replace,
            back,
            getCurrentRoute
        }
    },
    {
        persist: {
            storage: sessionStorage
        }
    }
)